// extracted by mini-css-extract-plugin
export default {"Footer":"Footer_Footer__qaFlk","footerContainer":"Footer_footerContainer__t2iiW","left":"Footer_left__nTzEh","right":"Footer_right__6B7b8"};